import styled, { createGlobalStyle } from 'styled-components';

const ModalWrapper = styled.div`
  display: flex;
  justify-content: center;
  height: 100vh;
  width: 100vw;
  background: rgba(0, 0, 0, 0.4);
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  overflow: hidden;

  @media screen and (min-width: 375px) {
    align-items: flex-end;
  }

  @media screen and (min-width: 768px) {
    align-items: center;
  }
`;

const ModalContent = styled.div`
  background-color: #fefefe;
  width: 50%;
  height: 70%;
  position: relative;
  overflow: auto;

  @media screen and (min-width: 375px) {
    min-width: 100%;
  }

  @media screen and (min-width: 768px) {
    min-width: 584px;
  }
`;

const ModalHeader = styled.div`
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 12px 20px;
  position: absolute;
  right: 0;
`;

const ModalCloseButton = styled.button`
  position: fixed;
  background-color: transparent;
  border: 0;
  cursor: pointer;
`;

const GlobalBodyStyle = createGlobalStyle`
  html, body {
    overflow-y: hidden;
  }
`;

export {
  ModalWrapper,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  GlobalBodyStyle,
};
